import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import { animated, useSpring, config } from 'react-spring';
import Img from 'gatsby-image';
import { useGlobalComponentsQuery } from '../../hooks/index';
import {
  desktopBreakpoint,
  colors,
  desktopVW,
  mobileVW,
  zIndex,
  DesktopView,
} from '../../styles/index';
import { SettingsContext } from '../../contexts';
import SubscribeForm from './SubscribeForm';
import Icons from '../../utils/Icons';

interface Props {}

export default function NewsletterPopup(props: Props) {
  const {} = props;

  const {
    setrenderNewsletterPopup,
    purchaseAllowed,
  }: {
    setrenderNewsletterPopup: any;
    purchaseAllowed: any;
  } = useContext(SettingsContext);

  const handleSetCookie = () => {
    Cookies.set('_DBNL-closed', true, { expires: 365 });
  };

  const handleClose = () => {
    handleSetCookie();
    setrenderNewsletterPopup(false);
  };

  const popupSpring = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: {
      ...config.stiff,
    },
  });

  const {
    newsletterTitleDomestic,
    newsletterTitleRow,
    newsletterParagraphDomestic,
    newsletterParagraphRow,
    newsletterPopupImage,
  }: {
    newsletterTitleDomestic: string;
    newsletterTitleRow: string;
    newsletterParagraphDomestic: string;
    newsletterParagraphRow: string;
    newsletterPopupImage: {
      fluid: string;
    };
  } = useGlobalComponentsQuery();

  return (
    <Wrapper style={{ ...popupSpring }}>
      <Background onClick={() => handleClose()} />
      <FormWrapper>
        <StyledImg fluid={newsletterPopupImage.fluid} />
        <Inner>
          <Title>
            {purchaseAllowed && purchaseAllowed.allowed
              ? newsletterTitleDomestic
              : newsletterTitleRow}
          </Title>
          <Paragraph>
            {purchaseAllowed && purchaseAllowed.allowed
              ? newsletterParagraphDomestic
              : newsletterParagraphRow}
          </Paragraph>
          <SubscribeForm />
          <Closebutton onClick={() => handleClose()}>
            <Icons name="close" />
          </Closebutton>
        </Inner>
      </FormWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(animated.div)`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndex.satan};
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const FormWrapper = styled.div`
  background-color: ${colors.frappuccino};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${desktopBreakpoint} {
    width: ${desktopVW(960)};
    height: ${desktopVW(560)};
    z-index: ${zIndex.satan + 1};
    flex-direction: row;
  }
`;

const StyledImg = styled(Img)`
  display: none;

  ${desktopBreakpoint} {
    display: block;
    width: 50%;
    height: 100%;
  }
`;

const Title = styled.div`
  font-family: 'messina';
  line-height: 90%;
  text-transform: uppercase;
  color: ${colors.black};
  width: 90%;
  font-size: ${mobileVW(25)};

  ${desktopBreakpoint} {
    font-size: ${desktopVW(30)};
    width: 63%;
  }
`;

const Paragraph = styled.div`
  font-family: 'messinaMono', 'Courier New', Courier, monospace;
  letter-spacing: -0.05em;
  color: ${colors.subtleGrey};
  font-size: ${mobileVW(18)};
  width: 90%;
  padding: ${mobileVW(20)} 0 0 0;

  ${desktopBreakpoint} {
    font-size: ${desktopVW(16)};
    padding: ${desktopVW(20)} 0 0 0;
    width: 63%;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${mobileVW(480)};
  position: relative;

  ${desktopBreakpoint} {
    width: 50%;
    height: 100%;
    justify-content: center;
  }
`;

const Closebutton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${mobileVW(20)} ${mobileVW(20)};

  ${desktopBreakpoint} {
    padding: ${desktopVW(20)} 0;
    top: 0;
    right: ${desktopVW(20)};
  }
`;
